/** @format */

import { Actions, createEffect, ofType } from '@ngrx/effects';

import { map } from 'rxjs/operators';

import { inject, Injectable } from '@angular/core';
import { userSetFulfillmentOption } from '../add-to-cart.actions';
import { setFulfillmentButtonsShipMode } from './fulfillment-buttons.actions';

@Injectable({ providedIn: 'root' })
export class FulfillmentButtonsEffects {
	private readonly actions$ = inject(Actions);

	updateAtcFulfillmentOption$ = createEffect(() =>
		this.actions$.pipe(
			ofType(setFulfillmentButtonsShipMode),
			map((action) => userSetFulfillmentOption({ atcFulfillmentOption: action.shipMode }))
		)
	);
}
